<script lang="ts">
  import GridLines from '$lib/components/GridLines.svelte';
  import GridContent from '$lib/components/GridContent.svelte';
  import GridInner from '$lib/components/GridInner.svelte';
  import Star from '$lib/components/Star.svelte';
  import { hatchStyle45 } from '$lib/styles/hatch';
</script>

<svelte:head>
  <title>Page Not Found - Corral AI</title>
</svelte:head>

<!-- Hero Section (light) -->
<section
  class="bg-[#f9f9f4] pt-16 pb-24 relative"
  style={hatchStyle45}
>
  <GridLines variant="light" />
  <GridContent>
    <GridInner>
      <div class="flex flex-col items-center text-center max-w-[700px] mx-auto">
        <!-- Eyebrow -->
        <p class="font-mono text-[14px] text-[#ee6018] uppercase tracking-wide mb-4">
          Error 404
        </p>

        <!-- Title -->
        <h1 class="font-display text-[48px] lg:text-[64px] text-[#020202] tracking-[-0.04em] leading-[1] mb-6">
          Page Not Found
        </h1>

        <!-- Subtitle -->
        <p class="font-body text-[16px] lg:text-[18px] text-[#5C5855] leading-relaxed">
          The page you're looking for doesn't exist or has been moved to a new location.
        </p>
      </div>
    </GridInner>
  </GridContent>
</section>

<!-- Content Section (dark) -->
<section class="bg-[#0d0d0d] relative">
  <GridLines variant="dark" />

  <!-- Top border with stars -->
  <div class="relative">
    <div class="hidden lg:block absolute top-0 left-0 right-0 h-px bg-[#333335]" aria-hidden="true"></div>
    <Star variant="bottom" class="hidden lg:block absolute left-[calc(9.03%-9px)] top-0" />
    <Star variant="bottom" class="hidden lg:block absolute right-[calc(9.03%-9px)] top-0" />
  </div>

  <GridContent class="py-20 lg:py-28">
    <GridInner>
      <div class="max-w-[500px] mx-auto text-center">
        <!-- Helpful suggestions -->
        <p class="font-mono text-[14px] text-[#878787] mb-8">
          Here are some helpful links instead:
        </p>

        <!-- Actions -->
        <div class="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <a
            href="/"
            class="bg-[#ee6018] text-white font-mono text-[14px] px-6 py-3 hover:bg-[#d55515] transition-colors"
          >
            Back to Home
          </a>
          <a
            href="/news"
            class="border border-[#333335] text-white font-mono text-[14px] px-6 py-3 hover:border-[#ee6018] transition-colors"
          >
            Read Our Blog
          </a>
        </div>

        <!-- Additional links -->
        <div class="flex flex-wrap justify-center gap-6">
          <a href="/product" class="font-mono text-[14px] text-[#878787] hover:text-[#ee6018] transition-colors">
            Product
          </a>
          <a href="/partners" class="font-mono text-[14px] text-[#878787] hover:text-[#ee6018] transition-colors">
            Partners
          </a>
          <a href="/learn" class="font-mono text-[14px] text-[#878787] hover:text-[#ee6018] transition-colors">
            Learn
          </a>
          <a href="/company/contact" class="font-mono text-[14px] text-[#878787] hover:text-[#ee6018] transition-colors">
            Contact
          </a>
        </div>
      </div>
    </GridInner>
  </GridContent>

  <!-- Bottom border with stars -->
  <div class="relative">
    <div class="hidden lg:block absolute bottom-0 left-0 right-0 h-px bg-[#333335]" aria-hidden="true"></div>
    <Star variant="top" class="hidden lg:block absolute left-[calc(9.03%-9px)] -bottom-px" />
    <Star variant="top" class="hidden lg:block absolute right-[calc(9.03%-9px)] -bottom-px" />
  </div>
</section>
